module.exports = __webpack_public_path__ + "img/inghomepay@3x.920500a.png";